export default __webpack_public_path__ + "static/media/carbon-image.05917994.png";